(() => {
  if (customElements.get('alx-cart-timer')) return;
  const key = 'aromalax-cart-reminder-v1';
  const read = () => { try { return JSON.parse(sessionStorage.getItem(key)); } catch { return window.AlxCartReminderState || null; } };
  const write = state => { window.AlxCartReminderState = state; try { if (state) sessionStorage.setItem(key, JSON.stringify(state)); else sessionStorage.removeItem(key); } catch {} };
  customElements.define('alx-cart-timer', class extends HTMLElement {
    connectedCallback() {
      this.clearHandler = () => { clearInterval(this.interval); this.hidden = true; };
      document.addEventListener('alx:cart-reminder-empty', this.clearHandler);
      if (Number(this.dataset.itemCount) === 0) {
        write(null);
        document.dispatchEvent(new CustomEvent('alx:cart-reminder-empty'));
        return;
      }
      const seconds = Math.max(10, Math.min(600, Number(this.dataset.seconds) || 120));
      let state = read();
      if (!state || state.seconds !== seconds || !Number.isFinite(state.deadline)) {
        state = { seconds, deadline: Date.now() + seconds * 1000 };
        write(state);
      }
      this.deadline = state.deadline;
      this.hidden = false;
      const phase = (seconds * 1000 - Math.max(0, this.deadline - Date.now())) % 1000;
      this.querySelector('.alx-cart-timer__icon').style.animationDelay = `-${phase}ms`;
      this.tick();
      if (this.deadline > Date.now()) this.interval = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      document.removeEventListener('alx:cart-reminder-empty', this.clearHandler);
    }
    tick() {
      const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      this.querySelector('[data-timer-clock]').textContent = `${String(Math.floor(remaining / 60)).padStart(2, '0')}:${String(remaining % 60).padStart(2, '0')}`;
      this.querySelector('[data-timer-active]').hidden = remaining === 0;
      this.querySelector('[data-timer-expired]').hidden = remaining !== 0;
      if (remaining === 0) clearInterval(this.interval);
    }
  });
})();
